<template>
    <v-autocomplete
        ref="input"
        v-model="selected"
        class="app-param-selector"
        :items="items"
        :loading="setupLoading"
        :disabled="setupLoading"
        :clearable="!required"
        hide-details
        :label="label"
        return-object
        :item-text="itemText"
        :item-value="itemKey"
        color="primaryText"
        item-color="primaryText"
        outlined
        dense
        @input="v => onItemSelected(v)"
        @clear="v => onItemSelected()"
    />
</template>

<script>
import { Collection } from '@/models';

export default {
    name: 'AppParamSelector',
    props: {
        collection: {
            type: Collection,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        paramKey: {
            type: String,
            default: 'id'
        },
        itemText: {
            type: String,
            default: 'name'
        },
        itemKey: {
            type: String,
            default: 'id'
        },
        route: {
            type: Object,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        loadObject: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        items: [],
        item: null,
        selected: null,
        redirect: {}
    }),
    methods: {
        async setup() {
            try {
                const paramValue = this.$route.params[this.paramKey];

                this.items = (await this.collection.request()).data;

                if (paramValue) {
                    this.selected = paramValue;
                } else if (this.required) {
                    this.onItemSelected(this.items[0]);
                }

                if (this.loadObject) {
                    this.$emit(
                        'load',
                        this.items.find(item => item[this.itemKey] === this.selected)
                    );
                } else {
                    this.$emit('load', this.selected);
                }
            } catch (error) {
                if (error?.code !== 404) {
                    this.handleError(error, () => this.setup());
                }
            }
        },
        onItemSelected(item) {
            const value = item ? item[this.itemKey] : null;
            const params = { [this.paramKey]: value };

            if (this.$route.params[this.paramKey] !== value) {
                this.redirect = this.route ? { params, ...this.route } : { name: this.$route.name, params };

                // this.$route.meta[this.paramKey] = value;
                this.$router.push(this.redirect).catch(() => {});
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.app-param-selector {
    min-width: 12rem;
}
</style>
